import qs from 'qs';

export const ORDER_COLUMNS = [
  { id: 'number', label: 'Order Number', alwaysVisible: true, orderable: true },
  { id: 'buyer', label: 'Buyer', orderable: true },
  { id: 'ticket_types', label: 'Ticket Types', orderable: true },
  { id: 'qty', label: 'Qty', orderable: true, align: 'right' },
  { id: 'price', label: 'Price', orderable: true, align: 'right' },
  { id: 'status', label: 'Status', orderable: true },
  { id: 'date', label: 'Date', orderable: true },
  { id: 'checked_in', label: 'Checked In', orderable: true },
  { id: 'seats', label: 'Seats', defaultHidden: true, orderable: true },
  { id: 'email', label: 'Email', defaultHidden: true, orderable: true },
  { id: 'phone', label: 'Phone', defaultHidden: true, orderable: false },
  { id: 'payment_method', label: 'Payment Method', defaultHidden: true, orderable: true },
  { id: 'point_of_sale', label: 'Point of Sale', defaultHidden: true, orderable: true },
];

export const orderColumnsFor = (confirm) => {
  const reservedSeating = Boolean(confirm.seatsio_event_id || confirm.add_on_seatsio_event_id);
  return ORDER_COLUMNS.map((column) => (column.id === 'seats' ? { ...column, defaultHidden: !reservedSeating } : column));
};

export const ORDER_STATUS_OPTIONS = [
  { value: 'valid', label: 'Valid', color: 'success' },
  { value: 'partially_refunded', label: 'Partially Refunded', color: 'warning' },
  { value: 'refunded', label: 'Refunded', color: 'purple' },
  { value: 'voided', label: 'Voided', color: 'gray' },
  { value: 'disputed', label: 'Disputed', color: 'error' },
];

export const CHECKED_IN_OPTIONS = [
  { value: 'checked_in', label: 'Checked in' },
  { value: 'partially_checked_in', label: 'Partially checked in' },
  { value: 'not_checked_in', label: 'Not checked in' },
];

export const POINT_OF_SALE_OPTIONS = [
  { value: 'Box Office', label: 'Box Office' },
  { value: 'Online', label: 'Online' },
];

export const ORDERS_PER_PAGE = 25;

export const DEFAULT_ORDER_SORT = { key: 'date', direction: 'desc' };

const REQUEST_COLUMN_IDS = ['json', ...ORDER_COLUMNS.map((column) => column.id), 'first_name', 'last_name'];

export const buildOrdersQuery = ({ sort, search }) => ({
  draw: 1,
  length: ORDERS_PER_PAGE,
  search: { value: search, regex: false },
  columns: Object.fromEntries(REQUEST_COLUMN_IDS.map((id, index) => [index, { data: id, searchable: true, orderable: true }])),
  order: { 0: { column: REQUEST_COLUMN_IDS.indexOf(sort.key), dir: sort.direction } },
});

export const serializeOrdersQuery = (params) => qs.stringify(params, { arrayFormat: 'brackets' });
